module.exports = __webpack_public_path__ + "static/media/fig_13b2.3772a0ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_13b2.jpg
// module id = 635
// module chunks = 0